/**
 * FooterNew (ported from facilio-website/components/footerNew.vue)
 * - Mobile accordion behavior
 * - Demo form validation + redirect to /request-demo/ with query params + sessionStorage
 */

(function () {
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function setAccordionOpen(accordion, open) {
    var header = $(".accordion-header", accordion);
    var body = $(".accordion-body", accordion);
    var arrow = $(".arrow", accordion);
    if (!header || !body) return;

    header.setAttribute("aria-expanded", open ? "true" : "false");
    if (arrow) arrow.classList.toggle("open", !!open);

    if (open) {
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      body.style.maxHeight = "0px";
    }
  }

  function initAccordions() {
    var accordions = $all(".footer-new-container .accordion-custom[data-footer-accordion]");
    accordions.forEach(function (accordion) {
      var header = $(".accordion-header", accordion);
      var body = $(".accordion-body", accordion);
      if (!header || !body) return;

      // Ensure a11y defaults
      if (!header.hasAttribute("aria-expanded")) header.setAttribute("aria-expanded", "false");

      // Start closed
      setAccordionOpen(accordion, false);

      header.addEventListener("click", function () {
        var isOpen = header.getAttribute("aria-expanded") === "true";
        setAccordionOpen(accordion, !isOpen);
      });

      header.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          header.click();
        }
      });
    });

    // Keep heights correct on resize
    var resizeTimeout = null;
    window.addEventListener("resize", function () {
      if (resizeTimeout) window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(function () {
        accordions.forEach(function (accordion) {
          var header = $(".accordion-header", accordion);
          var body = $(".accordion-body", accordion);
          if (!header || !body) return;
          var isOpen = header.getAttribute("aria-expanded") === "true";
          if (isOpen) {
            body.style.maxHeight = body.scrollHeight + "px";
          }
        });
      }, 100);
    });
  }

  function initDemoForm() {
    var form = $(".footer-new-container .footer-demo-form");
    if (!form) return;

    var companyInput = $("#footer-company", form);
    var emailInput = $("#footer-email", form);
    var companyErr = $('[data-error="company"]', form);
    var emailErr = $('[data-error="email"]', form);

    function clearErrors() {
      if (companyErr) {
        companyErr.textContent = "";
        companyErr.classList.remove("is-visible");
      }
      if (emailErr) {
        emailErr.textContent = "";
        emailErr.classList.remove("is-visible");
      }
      if (companyInput) companyInput.classList.remove("error");
      if (emailInput) emailInput.classList.remove("error");
    }

    function setError(which, message) {
      if (which === "company" && companyErr) {
        companyErr.textContent = message;
        companyErr.classList.add("is-visible");
      }
      if (which === "email" && emailErr) {
        emailErr.textContent = message;
        emailErr.classList.add("is-visible");
      }
      if (which === "company" && companyInput) companyInput.classList.add("error");
      if (which === "email" && emailInput) emailInput.classList.add("error");
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearErrors();

      var company = (companyInput && companyInput.value ? companyInput.value : "").trim();
      var email = (emailInput && emailInput.value ? emailInput.value : "").trim();

      var isValid = true;

      if (!company) {
        setError("company", "Company is required");
        isValid = false;
      }

      if (!email) {
        setError("email", "Email is required");
        isValid = false;
      } else {
        var emailRegex = /^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/;
        if (!emailRegex.test(email)) {
          setError("email", "Please enter a valid email");
          isValid = false;
        }
      }

      if (!isValid) return;

      try {
        window.sessionStorage.setItem(
          "footerFormData",
          JSON.stringify({
            company: company,
            email: email,
          })
        );
      } catch (err) {
        // ignore storage failures
      }

      var params = new URLSearchParams();
      params.set("company", company);
      params.set("email", email);
      window.location.href = "/request-demo/?" + params.toString();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAccordions();
      initDemoForm();
    });
  } else {
    initAccordions();
    initDemoForm();
  }
})();


